<template>
  <div>
    <div class="text-xs-right pa-1" style="height: 120px">
      <print-all-covers :orders="desserts"></print-all-covers>
    </div>
    <v-data-table
      expand
      :loading="loading"
      v-bind:pagination.sync="pagination"
      :headers="headers"
      :items="desserts"
      class="elevation-0 scgallrenttable"
    >
      <template v-slot:items="props">
        <tr style="cursor: pointer" @click="showOrderDetail(props.item.productdetail)">
          <td
            class="text-xs-center"
          >{{ props.item.first_name?props.item.first_name: '-' }} {{props.item.last_name?props.item.last_name: ''}}</td>
          <td
            class="px-0"
            style="min-width: 400px; border-right: 1px solid #ddd; border-left: 1px solid #ddd;"
          >
            <!-- <template v-if="typeof value.item.productlist == 'string'">
        <div class="pa-2">
          <nl2br tag="div" :text="order.productdetail"></nl2br>
        </div>
            </template>-->
            <template>
              <template v-for="(order, oindex) in JSON.parse(props.item.productdetail)">
                <v-layout wrap :key="'order_' + oindex">
                  <v-flex xs1>
                    <div class="ma-2">
                      <v-img :src="order.photourl" aspect-ratio="1" alt class="grey lighten-2">
                        <template v-slot:placeholder>
                          <v-layout fill-height align-center justify-center ma-0>
                            <!-- <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular> -->
                          </v-layout>
                        </template>
                      </v-img>
                    </div>
                  </v-flex>
                  <v-flex xs7>
                    <div class="ma-2">
                      {{ order.name }} x {{ order.quantity }}
                      <template
                        v-if="order.option"
                      >({{ order.option }})</template>
                      <div v-if="order.subproduct" class="grey--text">
                        <template v-for="(subproduct, sindex) in order.subproduct">
                          <div class="mb-1" :key="sindex">
                            {{ subproduct.name }} x {{ subproduct.quantity }}
                            <template
                              v-if="subproduct.option"
                            >({{ subproduct.option }})</template>
                          </div>
                        </template>
                      </div>
                    </div>
                  </v-flex>
                  <v-flex xs4 class="text-xs-right">
                    <div class="ma-2">฿{{ order.price | decimalFormat }}</div>
                  </v-flex>
                </v-layout>
                <v-divider
                  v-if="oindex < JSON.parse(props.item.productdetail).length - 1"
                  :key="oindex"
                ></v-divider>
              </template>
            </template>
          </td>
          <td class="text-xs-center">{{ props.item.nameaddress?props.item.nameaddress: '-' }}</td>
          <td class="text-xs-center">{{ props.item.payment?props.item.payment: '-' }}</td>
          <td class="text-xs-center">{{ props.item.status?props.item.status: '-' }}</td>
          <td class="text-xs-center">{{ props.item.total?props.item.total: '-' }}</td>
        </tr>
      </template>
    </v-data-table>
    <v-dialog persistent v-model="showdetail" width="800px">
      <v-card>
        <div class="text-xs-right">
          <v-btn icon @click="showdetail = false">
            <v-icon>close</v-icon>
          </v-btn>
        </div>
        <v-card-text>
          <v-data-table
            expand
            v-bind:pagination.sync="pagination"
            :headers="detailheaders"
            :items="detaildesserts"
            flat
            class="scgallrenttable"
          >
            <template v-slot:items="props">
              <tr>
                <td class="text-xs-center">
                  <v-avatar class="my-2" tile color="grey" size="50">
                    <img
                      class="responsive-img circle"
                      style="min-width: 100%"
                      alt
                      :src="props.item.photourl"
                    />
                  </v-avatar>
                </td>
                <td class="text-xs-center">{{ props.item.name?props.item.name: '-' }}</td>
                <td class="text-xs-center">{{ props.item.option?props.item.option: '-' }}</td>
                <td class="text-xs-center">{{ props.item.sku?props.item.sku: '-' }}</td>
                <td class="text-xs-center">{{ props.item.quantity?props.item.quantity: '-' }}</td>
                <td class="text-xs-center">{{ props.item.weight?props.item.weight: '-' }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import PrintAllCovers from '@/components/view/template/ecommerce/PrintAllCovers.vue'
import { setInterval, clearInterval } from 'timers'

export default {
  props: ['liveid'],
  components: {
    PrintAllCovers: PrintAllCovers,
  },
  data() {
    return {
      orderInterval: '',
      showdetail: false,
      orderdetail: [],
      loading: false,
      pagination: { sortBy: 'none', descending: true, rowsPerPage: 15 },
      data: [],
      headers: [
        { text: this.$t('Name'), value: 'first_name', align: 'center' },
        { text: this.$t('Orders'), value: 'orders', align: 'center' },
        { text: this.$t('Address'), value: 'nameaddress', align: 'center' },
        { text: this.$t('Payment'), value: 'payment', align: 'center' },
        { text: this.$t('Status'), value: 'status', align: 'center' },
        { text: this.$t('Total'), value: 'total', align: 'center' },
      ],
      detailheaders: [
        { text: this.$t('Photo'), value: 'photourl', align: 'center' },
        { text: this.$t('Name'), value: 'name', align: 'center' },
        { text: this.$t('Option'), value: 'option', align: 'center' },
        { text: this.$t('SKU'), value: 'sku', align: 'center' },
        { text: this.$t('Quantity'), value: 'quantity', align: 'center' },
        { text: this.$t('Weight'), value: 'weight', align: 'center' },
      ],
      desserts: [],
      detaildesserts: [],
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
  },
  mounted() {
    this.getordersummarylive()
    this.orderInterval = setInterval(() => {
      this.getordersummarylive()
    }, 10000)
  },
  beforeDestroy() {
    this.destroyInterval()
  },
  methods: {
    destroyInterval() {
      this.detaildesserts = []
      clearInterval(this.orderInterval)
    },
    showOrderDetail(detail) {
      this.detaildesserts = JSON.parse(detail)
      this.showdetail = true
    },
    getordersummarylive() {
      api.getordersummarylive(
        { pageid: this.selectedBot.pageid, liveid: this.liveid },
        (err, response) => {
          if (response.data) {
            this.desserts = response.data
          } else {
            this.desserts = []
          }
        }
      )
    },
  },
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/view/live/OrderSummary.vue